// extracted by mini-css-extract-plugin
export default {"row_wrapper":"ProjectProtocolsTableHeaderRow_row_wrapper__XhuOh","row":"ProjectProtocolsTableHeaderRow_row__kTfPL"};